import React, { useEffect, useMemo, useState } from "react"
import { getAPIBaseURL } from "../../services/helpers"
import { Link } from "react-router-dom"
import { getData } from "../../services/request"

const AdminHospitals = () => {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const [query, setQuery] = useState("")

  const fetchItems = async () => {
    setLoading(true)
    setError("")
    const url = `${getAPIBaseURL()}/v1/users`
    const params = { role: 'HOSPITAL', limit: 200, skip: 0 }
    const res = await getData(url, {}, params)
    setLoading(false)
    if(res.error == ""){
      if(res.result.status === 200){
        setItems(res.result.data?.data || [])
      }else{
        setError(res.result.data?.message || 'Failed to load hospitals')
      }
    }else{
      setError(res.result?.data?.message || 'Network error')
    }
  }

  useEffect(()=>{ fetchItems() }, [])

  const filtered = useMemo(()=>{
    const q = query.trim().toLowerCase()
    if(!q) return items
    return items.filter(u => (
      (u.organization || '').toLowerCase().includes(q) ||
      (u.email || '').toLowerCase().includes(q) ||
      (u.phoneNumber || '').toLowerCase().includes(q)
    ))
  }, [items, query])

  return (
    <section className="mx-auto max-w-6xl">
      <div className="mb-4 flex items-center justify-between gap-3">
        <h1 className="text-2xl font-bold text-gray-900">Hospitals</h1>
        <input
          value={query}
          onChange={(e)=>setQuery(e.target.value)}
          placeholder="Search hospitals (name, email, phone)"
          className="w-72 max-w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-black focus:outline-none focus:ring-2 focus:ring-black"
        />
      </div>

      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
        {loading ? (
          <div className="p-6 text-sm text-gray-500">Loading...</div>
        ) : error ? (
          <div className="p-6 text-sm text-red-600">{error}</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 text-left text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 font-semibold text-gray-700">Hospital</th>
                  <th className="px-4 py-3 font-semibold text-gray-700">Email</th>
                  <th className="px-4 py-3 font-semibold text-gray-700">Phone</th>
                  <th className="px-4 py-3 font-semibold text-gray-700">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {filtered.map(u => (
                  <tr key={u._id} className="hover:bg-gray-50">
                    <td className="px-4 py-3">
                      <Link to={`/admin/app/hospitals/${u._id}`} className="font-medium text-gray-900 hover:underline">{u.organization}</Link>
                      <div className="text-xs text-gray-500">State {u.state} · LGA {u.localGovernment}</div>
                    </td>
                    <td className="px-4 py-3 text-gray-700">{u.email}</td>
                    <td className="px-4 py-3 text-gray-700">{u.phoneNumber}</td>
                    <td className="px-4 py-3">
                      <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${u.status === 1 ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                        {u.status === 1 ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filtered.length === 0 ? (
              <div className="p-6 text-sm text-gray-500">No matching hospitals</div>
            ) : null}
          </div>
        )}
      </div>
    </section>
  )
}

export default AdminHospitals


